import React from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware } from "redux";
// import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Provider } from "react-redux";
import ls from "local-storage";
import "@fontsource/roboto";
import "@fontsource/chewy";
import "@fontsource/dosis/800.css";
import "@fontsource/cabin-sketch";
// import { AppContainer } from 'react-hot-loader';

// import CountUpGame from './components/CountUpGame';

import AppWrapper from "./containers/AppWrapper";
import reducer from "./reducers";
import * as Actions from "./actions";
import {
  getStoredData,
  setStoredData,
  checkGridData,
  convertGameToHash,
  convertHashToGame,
} from "./utils/gameHelpers";

// import './style.css';
// console.log("checkGridData1", ls("grids"));
checkGridData();
// console.log("checkGridData2", ls("grids"));

/**
 * Logs all actions and states after they are dispatched.
 */
const logger = (store) => (next) => (action) => {
  console.group(action.type);
  console.info("dispatching", action);
  const result = next(action);
  console.log("next state", store.getState());
  console.groupEnd(action.type);
  return result;
};

const formatGridString = (gs) =>
  gs
    .split(",")
    .map((a) => parseInt(a, 10))
    .sort((a, b) => a - b)
    .join(",");

const getGridForLs = (game) => {
  const grids = ls("grids");
  const gameString = `${game.target},${game.grid.join(",")}`;
  let out = gameString;
  grids.forEach((g) => {
    // const gs = formatGridString(g);
    // console.log("grid fe", gs, gameString, formatGridString(gameString));
    if (formatGridString(g) === formatGridString(gameString)) out = g;
  });
  // console.log("getGridForLs", game, grids, gameString, out);
  return out;
};

const useStorage = (store) => (next) => (action) => {
  const prevSolutions = store.getState().game.solutions;
  // const prevTheme = store.getState().app.theme;
  const result = next(action);
  const state = store.getState();
  const grid = getGridForLs(state.game);
  if (action.type === "NEW_GAME" || action.type === "LOAD_GAME") {
    const { solutions } = getStoredData(grid);
    store.dispatch(Actions.loadSolutions(solutions));
    // console.log('getStoredData theme', JSON.parse(localStorage.getItem('theme')));
    // store.dispatch(Actions.setAppTheme(JSON.parse(localStorage.getItem('theme'))));
  } else if (action.type === "CLICK_TILE") {
    if (state.game.solutions.length > prevSolutions.length) {
      // new solution found...
      setStoredData(grid, { solutions: state.game.solutions });
    }
  }
  // if (state.app.theme !== prevTheme) {
  //   console.log('diff theme', state.app.theme, prevTheme)
  //   setStoredData('theme', state.app.theme);
  //   // window.location.reload();
  // }
  return result;
};

const setHash = (store) => (next) => (action) => {
  const result = next(action);
  if (action.type === "NEW_GAME" || action.type === "LOAD_GAME") {
    const state = store.getState();
    // window.location.hash = `${state.game.target},${state.game.grid.join(",")}`;
    window.location.hash = convertGameToHash(state.game);
  }
  return result;
};

if (false) console.log(logger);

const store = createStore(reducer, applyMiddleware(useStorage, setHash));

const updateScreenSize = () =>
  store.dispatch(Actions.screenResize(window.innerWidth, window.innerHeight));
window.addEventListener("resize", () => {
  updateScreenSize();
});
updateScreenSize();

const loadGame = (hash) => {
  // const saveGame = game.split(",").map((n) => parseInt(n, 10));
  // const target = saveGame.shift();
  // let grid = saveGame;
  // const rows = Math.floor(Math.sqrt(grid.length));
  // const cols = Math.floor(grid.length / rows);
  // grid = grid.slice(0, rows * cols);
  const state = store.getState();
  if (convertGameToHash(state.game) === hash) return; // SAME
  // console.log("loadGame h", convertGameToHash(state.game), hash);
  const game = convertHashToGame(hash);
  // console.log("loadGame", state.game.target, game.target);
  if (game === false) {
    console.log("ERROR with game hash");
  } else {
    store.dispatch(Actions.loadGame(game.target, game.grid));
  }
};
const loadGameFromHash = () => {
  // console.log("loadGameFromHash");
  if (window.location.hash.length > 1) loadGame(window.location.hash.substr(1));
};

if (window.location.hash) {
  loadGameFromHash();
} else if (ls("currentGrid")) {
  loadGame(ls("currentGrid"));
  store.dispatch(Actions.toggleTitleScreen());
}

window.addEventListener("hashchange", () => {
  loadGameFromHash();
});

// const onDeviceReady = () => {
//   window.removeEventListener("deviceready", onDeviceReady, false);

//   if (window.cordova && window.AdMob) {
//     window.AdMob.setOptions({
//       publisherId: "ca-app-pub-2379142366574646~4225681437",
//     });
//     console.log("admob ON");
//   } else console.log("admob OFF");
// };

// window.addEventListener("deviceready", onDeviceReady, false);

// const isDarkMode = (onSuccess) => {
//   // console.log('isDarkMode');
//   if (
//     typeof cordova !== 'undefined' &&
//     cordova &&
//     cordova.plugins &&
//     cordova.plugins.ThemeDetection &&
//     typeof cordova.plugins.ThemeDetection.isDarkModeEnabled === 'function'
//   ) {
//     cordova.plugins.ThemeDetection.isDarkModeEnabled(onSuccess);
//   } else {
//     onSuccess({ message: 'No Plugin', value: false });
//   }
// };

// const state = store.getState();
// console.log('getState', state);
// let modeFromPlugin = false;
// const isDark = () => {
//   if (state.app.theme === 'dark') return true; // app set to dark
//   if (state.app.theme === 'light') return false; // app set to light
//   if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) return true; // css set to dark
//   if (modeFromPlugin === false) {
//     isDarkMode((m) => {
//       modeFromPlugin = m;
//     });
//   }
//   if (typeof modeFromPlugin === 'object' && modeFromPlugin.value) return modeFromPlugin.value;
//   return false;
// };
// const theme = createMuiTheme({
//   palette: {
//     primary: lightBlue,
//     secondary: pink,
//     error: red,
//     contrastThreshold: 3,
//     tonalOffset: 0.2,
//     type: isDark() ? 'dark' : 'light',
//   },
// });

const render = (Component) => {
  ReactDOM.render(
    <Provider store={store}>
      <Component />
    </Provider>,
    document.getElementById("root")
  );
};
if (!window.cordova) {
  render(AppWrapper);
} else {
  document.addEventListener("deviceready", () => render(AppWrapper), false);
}
// render(AppWrapper);

if (module.hot) {
  module.hot.accept("./containers/AppWrapper", () => {
    render(AppWrapper);
  });
}
